import { AllImmsCompletedForRoleCertificate as Certificate }
    from "@teamprevent/common/immunisation/components/AllImmsCompletedForRoleCertificate";

import { connect } from "react-redux";

import { allImmsCompletedForRoleApi } from "../allImmsCompletedForRoleApi";
import { ApplicationState } from "../../applicationState";

const mapStateToProps = (state: ApplicationState) => {
    const employeeRecordId = state.router.params.employeeRecordId;
    const ohCaseId = state.router.params.ohCaseId;
    const taskId = state.router.params.taskId;
    return { loadCertificateDetails: () => allImmsCompletedForRoleApi.getAllImmsCompletedForRoleCertificate(employeeRecordId, ohCaseId, taskId) };
};

export const AllImmsCompletedForRoleCertificate = connect(mapStateToProps)(Certificate);
